module.exports = __webpack_public_path__ + "static/2front-web-1-08c8ab4b159d5c1127d16cfd038b876c.png";